import React from 'react';

export default function OurProducts() {
	return (
		<div className='flex items-end justify-between px-15 mt-15'>
			<p className='text-16 mb-15'>Nasze produkty</p>
			<img src='files/sf.png' alt='Nasze produkty' width='40%' height='40%' />
		</div>
	);
}
